import { baseApi } from "@/shared/api";
import type { ProjectMember, OrgMember } from "../types";

export const membersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProjectMembers: builder.query<ProjectMember[], number>({
      query: (projectId) => ({
        url: `/api/projects/${projectId}/members/`,
        method: "GET",
        credentials: "include" as const,
      }),
      providesTags: (_result, _error, projectId) => [
        { type: "ProjectMembers", id: `PROJECT-${projectId}` },
      ],
    }),
    addProjectMember: builder.mutation<ProjectMember, { projectId: number; userId: number }>({
      query: ({ projectId, userId }) => ({
        url: `/api/projects/${projectId}/members/`,
        method: "POST",
        body: { user_id: userId },
        credentials: "include" as const,
      }),
      invalidatesTags: (_result, _error, { projectId }) => [
        { type: "ProjectMembers", id: `PROJECT-${projectId}` },
        { type: "Projects", id: "LIST" },
        { type: "Projects", id: projectId },
        { type: "TaskBoard", id: "LIST" },
      ],
    }),
    removeProjectMember: builder.mutation<void, { projectId: number; userId: number }>({
      query: ({ projectId, userId }) => ({
        url: `/api/projects/${projectId}/members/${userId}/`,
        method: "DELETE",
        credentials: "include" as const,
      }),
      invalidatesTags: (_result, _error, { projectId }) => [
        { type: "ProjectMembers", id: `PROJECT-${projectId}` },
        { type: "Projects", id: "LIST" },
        { type: "Projects", id: projectId },
        { type: "TaskBoard", id: "LIST" },
      ],
    }),
    getOrgMembers: builder.query<OrgMember[], void>({
      query: () => ({
        url: "/api/projects/org-members/",
        method: "GET",
        credentials: "include" as const,
      }),
    }),
  }),
});

export const {
  useGetProjectMembersQuery,
  useAddProjectMemberMutation,
  useRemoveProjectMemberMutation,
  useGetOrgMembersQuery,
} = membersApi;
